import { LoanappService } from './../../services/loanapp.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, tap, filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import * as moment from 'moment';
import { numberWithCommaService } from 'app/services/numberWithComma.service';
import { ExportService } from 'app/services/export.service';

declare var $: any;

@Component({
  selector: 'app-loanapplications',
  templateUrl: './loanapplications.component.html',
  styleUrls: ['./loanapplications.component.css'],
})
export class LoanapplicationsComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  tprice: any;
  filterWnameArr: Array<any> = [];
  loanAppsLoaded: Boolean = false;

  showClearFilterBtn: Boolean = false;

  totalRec: number = 0;
  dateRange: any = 'Select Date';
  dateQueryParam: any = null;

  searchForm = new FormGroup({
    nameOrId: new FormControl(''),
    pageLimit: new FormControl(10),
  });

  runningQuery: Subscription;

  fileHeaders = [
    'Application ID',
    'WHR Number',
    'Name of Borrower',
    'Loan Application Date',
    'Commodity Type',
    'Net Quantity',
    'Unit Price',
    'Value of Stock',
    'Approved Loan Amount',
    'Loan Application Status',
    'CMA Appointment Status',
  ];

  constructor(
    private lservice: LoanappService,
    private router: Router,
    private toastr: ToastrService,
    private numberFormat: numberWithCommaService,
    private exportService: ExportService
  ) {}

  ngOnInit() {
    this.searchForm
      .get('nameOrId')
      .valueChanges.pipe(
        debounceTime(100),
        tap(() => {
          this.p = 1;
        })
      )
      .subscribe(() => {
        this.runningQuery = this.getLoanApp().subscribe(
          (data) => this.gotLoanApplication(data),
          (err) => this.failedToGetLoanApplications(err)
        );
      });

    this.searchForm
      .get('pageLimit')
      .valueChanges.pipe(
        debounceTime(100),
        filter((value) => value > 0),
        tap((value) => {
          this.p = 1;
          this.itemsPerPage = value;
        })
      )
      .subscribe(() => {
        this.runningQuery = this.getLoanApp().subscribe(
          (data) => this.gotLoanApplication(data),
          (err) => this.failedToGetLoanApplications(err)
        );
      });

    this.runningQuery = this.getLoanApp().subscribe(
      (data) => this.gotLoanApplication(data),
      (err) => this.failedToGetLoanApplications(err)
    );
  }

  filterQueryParams(createFor = 'listing') {
    const params: any = {};

    if (createFor === 'listing') {
      params.page = String(this.p);
      params.limit = String(this.itemsPerPage);
    }

    const searchFor = this.searchForm.get('nameOrId').value;

    if (searchFor) params.searchFor = searchFor;

    if (this.dateQueryParam) {
      params.startDate = this.dateQueryParam.startDate;
      params.endDate = this.dateQueryParam.endDate;
    }

    return params;
  }

  getLoanApp(getFor = 'listing') {
    this.loanAppsLoaded = false;
    const params = this.filterQueryParams(getFor);

    if (this.runningQuery) this.runningQuery.unsubscribe();

    return this.lservice.getLoanApp(params);
  }

  gotLoanApplication(data) {
    this.dataRec = true;
    this.loanAppsLoaded = true;

    if (data['success']) {
      this.lApplications = data['data'];
      this.dataToShow = data['data'];
      this.totalRec = data['appCount'];
      for (let i = 0; i < this.dataToShow.length; i++) {
        this.dataToShow[i]['tprice'] =
          this.dataToShow[i]['depositApp']['depositQty'] *
          this.dataToShow[i]['depositApp']['perUnitValue'];
        if (
          !this.isInArray(
            this.lApplications[i]['warehouseName'],
            this.filterWnameArr
          )
        ) {
          this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
        }
      }
    }
  }

  failedToGetLoanApplications(err) {
    this.loanAppsLoaded = true;
  }

  getNewPage(page) {
    this.p = page;
    this.runningQuery = this.getLoanApp().subscribe(
      (data) => this.gotLoanApplication(data),
      (err) => this.failedToGetLoanApplications(err)
    );
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  public chosenDate(value: any) {
    this.showClearFilterBtn = true;
    this.dateQueryParam = value;
    this.p = 1;

    this.runningQuery = this.getLoanApp().subscribe(
      (data) => this.gotLoanApplication(data),
      (err) => this.failedToGetLoanApplications(err)
    );

    // let sDate = new Date(value.startDate);
    // let eDate = new Date(value.endDate);
    // console.log(sDate);
    // console.log(eDate);
    // this.findApplicationsByDate(sDate, eDate);
  }

  findApplicationsByDate(sDate, eDate) {
    this.lservice.filterByDatePendingApp(sDate, eDate).subscribe(
      (data) => {
        if (data['success']) {
          this.dataToShow = data['data'];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  clearFilters() {
    this.showClearFilterBtn = false;
    this.dateQueryParam = null;
    this.p = 1;

    this.runningQuery = this.getLoanApp().subscribe(
      (data) => this.gotLoanApplication(data),
      (err) => this.failedToGetLoanApplications(err)
    );
  }

  fileWriteArray(dataToWrite) {
    return dataToWrite.map((data) => ({
      'Application ID': data._id,
      'WHR Number':
        data.depositApp && data.depositApp.mswcReceiptId
          ? data.depositApp.mswcReceiptId
          : data.blockchainReceiptId,
      'Name of Borrower': data.applicantName,
      'Loan Application Date': moment(data.timestamp).format('MMM D, YYYY'),
      'Warehouse Name': data.warehouseName,
      'Commodity Type':
        data.commodityId && data.commodityId.name
          ? data.commodityId.name
          : data.commodityName,
      'Net Quantity': `${data.depositQty} ${data.depositUom}`,
      'Unit Price': data.depositApp
        ? Number(data.depositApp.perUnitValue)
        : 'nil',
      'Value of Stock': data.totalReceiptValue,
      'Approved Loan Amount': data.approved ? data.approved.loanAmount : 'nil',
      'Loan Application Status': data.applicationStatus,
      'CMA Appointment Status': data.cmaAppointmentstatus,
      'Lien Marked': data.applicationStatus === 'approved' ? 'Yes' : 'No',
    }));
  }

  writeToPDF(dataToWrite) {
    const doc = new jsPDF('landscape');
    const rows = this.fileWriteArray(dataToWrite).map((data) =>
      this.fileHeaders.map((h) => data[h])
    );

    doc.setFontSize(9);
    doc.autoTable(this.fileHeaders, rows);
    doc.save('Loan_Applications' + new Date().toDateString() + '.pdf');
  }

  downloadPDF() {
    this.runningQuery = this.getLoanApp('download').subscribe(
      (response) => {
        this.dataRec = true;
        this.loanAppsLoaded = true;
        const data = response['data'];
        this.writeToPDF(data);
      },
      (err) => this.failedToGetLoanApplications(err)
    );
  }

  getDate(d) {
    let f = new Date(d);
    let dateString = f.toString().slice(0, 15);
    return dateString;
  }

  print(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    location.reload();
  }

  writeToCSV(dataToWrite) {
    const downArr = this.fileWriteArray(dataToWrite);

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: this.fileHeaders,
      showTitle: false,
      title: 'name',
      useBom: false,
      removeNewLines: true,
      noDownload: false,
    };
    this.exportService.excel(
      Object.keys(downArr.length ? downArr[0] : []),
      downArr,
      `Loan_Applications_Pending-${new Date().toDateString()}`
    );
    // new AngularCsv(
    //   downArr,
    //   'Loan_Applications-' + new Date().toDateString(),
    //   options
    // );
  }

  downloadCSV() {
    this.runningQuery = this.getLoanApp('download').subscribe(
      (response) => {
        this.dataRec = true;
        this.loanAppsLoaded = true;
        const data = response['data'];
        this.writeToCSV(data);
      },
      (err) => this.failedToGetLoanApplications(err)
    );
  }

  rowclick(value) {
    this.appObj = value;
    if (value['user']) {
      window.location.href =
        '/loanapplicationdetails?id=' +
        value['_id'] +
        '&uId=' +
        value['user']['_id'] +
        '&ref=loanapplications';
    } else {
      // window.location.href = '/loanapplicationdetails?id=' + value['_id'] + '&uId=' + value['submittedBy'] + '&ref=loanapplications';
      this.toastr.error('No User found against this application.');
    }
  }

  toggleMenu() {
    $('#sidebar').toggleClass('active');
    $('#rotateN').toggleClass('rotate180');
    $('#sidebarCollapse').toggleClass('m10Sty');
    let elem = document.getElementById('asdsadada');
    if (elem.classList.contains('disnone')) {
      setTimeout(() => {
        $('#asdsadada').toggleClass('disnone');
      }, 200);
    } else {
      $('#asdsadada').toggleClass('disnone');
    }
  }

  onSearchChange(searchValue: string) {
    if (searchValue !== '') {
      this.dataToShow = this.filterItems(searchValue);
    } else {
      this.dataToShow = this.lApplications;
    }
  }

  filterItems(searchTerm) {
    return this.lApplications.filter((item) =>
      Object.keys(item).some(
        (k) =>
          item[k] != null &&
          item[k].toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }

  onChangeWname(wname) {
    if (wname !== '') {
      this.dataToShow = this.filterWname(wname);
    } else {
      this.dataToShow = this.lApplications;
    }
  }
  filterWname(searchTerm) {
    let bArr = [];
    for (let u = 0; u < this.lApplications.length; u++) {
      if (
        this.lApplications[u].warehouseName.toLowerCase() ==
        searchTerm.toLowerCase()
      ) {
        bArr.push(this.lApplications[u]);
      }
    }
    return bArr;
  }

  onChangeStatus(status) {
    if (status !== '') {
      this.dataToShow = this.filterStatus(status);
    } else {
      this.dataToShow = this.lApplications;
    }
  }
  filterStatus(searchTerm) {
    let bArr = [];
    for (let u = 0; u < this.lApplications.length; u++) {
      if (
        this.lApplications[u].applicationStatus.toLowerCase() ==
        searchTerm.toLowerCase()
      ) {
        bArr.push(this.lApplications[u]);
      }
    }
    return bArr;
  }
  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
}
